module.exports = __webpack_public_path__ + "static/top-talent-f6e3f5c685301e64ce1ba823783d6861.svg";